import { DATE_FORMAT_MM_DOT_YYYY } from 'constants/formats';
import dayjs from 'dayjs';

export const getMMYYYYformattedDate = (date: dayjs.Dayjs): string => date.format(DATE_FORMAT_MM_DOT_YYYY);
